<template>
  <div>
    <div class="renderDay">
      <div class="firstDateFormBlock" @click="showStartDatePopup = true">
        <div class="firstDateForm">
          {{ getNowFormatDate(startDate) }}
          {{ formatDate(startDate).split(' ')[1] }}
        </div>
        <div class="firstDateText">
          <div>{{ dayStartTime }}</div>
          <div class="firstDateLine">-</div>
          <div>{{ dayEndTime }}</div>
        </div>
      </div>
      <img class="arrow_left" src="@/assets/images/arrow-left-f@2x.png" alt="" />
      <div class="firstDateFormBlock" @click="showEndDatePopup = true">
        <div class="firstDateForm">
          {{ getNowFormatDate(endDate) }} {{ formatDate(endDate).split(' ')[1] }}
        </div>
        <div class="firstDateText">
          <div>{{ dayStartTime }}</div>
          <div class="firstDateLine">-</div>
          <div>{{ dayEndTime }}</div>
        </div>
      </div>
    </div>

    <div class="appointmentTime">
      {{ $t('已选择 ') }}{{ diffNum }}{{ $t(' 天') }}
    </div>
    <!-- 开始时间 -->
    <van-popup v-model="showStartDatePopup" position="bottom" v-if="showStartDatePopup" @close-on-click-overlay="false">
      <van-datetime-picker type="date" :title="$t('选择年月日')" :value="startDate" :min-date="minDate"
        :max-date="maxStartDate" @confirm="handleConfirmStartDay" @cancel="showStartDatePopup = false"
        @change="handleChangeStartDay" />
    </van-popup>
    <!-- 结束时间 -->
    <van-popup v-model="showEndDatePopup" position="bottom" v-if="showEndDatePopup" @close-on-click-overlay="false">
      <van-datetime-picker type="date" :title="$t('选择年月日')" :value="endDate" :min-date="minDate" :max-date="maxEndDate"
        @confirm="handleConfirmEndDay" @cancel="showEndDatePopup = false" />
    </van-popup>
  </div>
</template>
<script>
import { fixNewDate } from '@/utils/utils'
import Vue from 'vue'
import {
  getNowFormatDate,
  formatDate,
  formatDateYMD,
  formatDateYMDHMS,
  mergeTimeRanges,
  excludeTimeRanges,
  getRangesByStartEnd,
} from '@/views/station/utils'
import dayjs from 'dayjs'
import moment from 'moment'
import { queryDisableDate } from '@/services/api'
import { Toast } from 'vant'

Vue.use(Toast)

export default {
  name: 'RenderDay',
  data() {
    return {
      showStartDatePopup: false,
      showEndDatePopup: false,
      startDate: new Date(fixNewDate(this.$route.params.startTime)), // 开始日期（年月日-天）
      endDate: new Date(fixNewDate(this.$route.params.endTime)), // 结束日期（年月日-天）\
      diffNum: 1,
      bookedDates: [],
      changeStartValue: moment().format('YYYY-MM-DD'),
      minDate: new Date(),
      maxStartDate: new Date(),
      // minEndDate: new Date(),
      maxEndDate: new Date(),

      getNowFormatDate,
      formatDate,
      formatDateYMD,
      formatDateYMDHMS,
      mergeTimeRanges,
      getRangesByStartEnd,
    }
  },
  methods: {
    async initQuery() {
      const rangeDateForSubmit = getRangesByStartEnd(
        moment(this.startDate),
        moment(this.endDate),
        this.appointmentConfig
      )
      this.onChangeDate('start', this.startDate, this.endDate, rangeDateForSubmit)
      // this.onChangeDate(
      //   'end',
      //   this.endDate,
      //   rangeDateForSubmit
      // )

      const maxMakeDay = this.appointmentConfig.maxMakeDay
        ? this.appointmentConfig.maxMakeDay
        : 20 // 最长预约天数
      try {
        const res = await queryDisableDate({
          stationId: this.checkedStationId,
          startTime: `${dayjs().format('YYYY-MM-DD')} 00:00:00`,
          endTime: `${dayjs()
            .add(maxMakeDay, 'day')
            .format('YYYY-MM-DD')} 23:59:59`,
          type: 'DAY',
        })

        let sortByStartTime = []
        // 1. 按照开始时间进行生序
        sortByStartTime = res?.data.sort(
          (a, b) =>
            moment(a.startTime).valueOf() - moment(b.startTime).valueOf()
        )
        // 2. 相邻的时间段进行合并
        let newDateList = this.mergeTimeRanges(sortByStartTime)

        this.bookedDates = newDateList

        // 初始化更新一下值
        // const rangeDateForSubmit = excludeTimeRanges(
        //   {
        //     startTime: formatDateYMDHMS(this.startDate),
        //     endTime: `${formatDateYMD(this.endDate)} 23:59:59`,
        //   },
        //   this.bookedDates
        // )
      } catch (error) {
        console.log(error)
      }
    },
    initSetDate() {
      const rangeDateForSubmit = getRangesByStartEnd(
        moment(this.startDate),
        moment(this.endDate),
        this.appointmentConfig
      )
      this.onChangeDate('start', this.startDate, this.endDate, rangeDateForSubmit)
      // this.onChangeDate(
      //   'end',
      //   this.endDate,
      //   rangeDateForSubmit
      // )
      const maxDate = this.appointmentConfig.maxMakeDay
        ? this.appointmentConfig.maxMakeDay
        : 20 // 最长预约天数
      const singleMaxMakeTime = this.appointmentConfig.appointmentShowDays
        ? this.appointmentConfig.appointmentShowDays
        : 1 // 用于天、自定义时间
      let maxStartDate = new Date()
      // maxStartDate.setDate(this.startDate.getDate() + Number(maxDate) - 1)
      maxStartDate.setDate(new Date().getDate() + Number(maxDate) - 1)
      this.maxStartDate = maxStartDate

      let maxEndDate = new Date(this.startDate)
      maxEndDate.setDate(
        this.startDate.getDate() + Number(singleMaxMakeTime) - 1
      )
      if (maxEndDate.getTime() > maxStartDate.getTime()) {
        this.maxEndDate = maxStartDate
      } else {
        this.maxEndDate = maxEndDate
      }
    },
    // 根据配置的最大预约时间显示过滤数据
    filterStartDay(type, options) {
      const currentCheckedDate = dayjs(this.startDate)
      const curY = dayjs().year()
      const curM = Number(dayjs().format('MM'))
      const curD = Number(dayjs().format('DD'))

      const maxDate = this.appointmentConfig.maxMakeDay
        ? this.appointmentConfig.maxMakeDay
        : 20 // 最长预约天数
      const maxMakeDay = dayjs().add(maxDate, 'day') //最大预约天数

      const maxY = maxMakeDay.year()
      const maxM = Number(maxMakeDay.format('MM'))
      const maxD = Number(maxMakeDay.format('DD'))

      const isCurY =
        dayjs().format('YYYY') === currentCheckedDate.format('YYYY')
      const isCurM =
        dayjs().format('YYYY-MM') === currentCheckedDate.format('YYYY-MM')
      const checkedY = currentCheckedDate.year()
      const checkedM = currentCheckedDate.month() + 1
      // console.log('---type:', type)
      // console.log('---options:', options)

      // if (type === 'year') {
      //   return options.filter(option => Number(option) >= curY && Number(option) <= maxY)
      // }
      // if (type === 'month') {
      //   if (isCurY) {
      //     if (checkedY === maxY) {
      //       return options.filter(option => Number(option) >= curM && Number(option) <= maxM)
      //     } else {
      //       return options.filter(option => Number(option) >= curM)
      //     }
      //   } else {
      //     if (checkedY === maxY) {
      //       return options.filter(option => Number(option) <= maxM)
      //     }
      //   }
      // }
      // if (type === 'day') {
      //   if (isCurY) {
      //     if (checkedY === maxY) {
      //       if (isCurM) {
      //         if (checkedM === maxM) {
      //           return options.filter(option => Number(option) >= curD && Number(option) <= maxD)
      //         } else {
      //           return options.filter(option => Number(option) >= curD)
      //         }
      //       } else {
      //         if (checkedM === maxM) {
      //           return options.filter(option => Number(option) <= maxD)
      //         }
      //       }
      //     }
      //   } else {
      //     if (checkedY === maxY) {
      //       if (checkedM === maxM) {
      //         return options.filter(option => Number(option) <= maxD)
      //       }
      //     }
      //   }
      // }
      // return options

      let newOptions = []

      if (type === 'year') {
        newOptions = options.filter(
          (option) => Number(option) >= curY && Number(option) <= maxY
        )
      }
      if (type === 'month') {
        if (isCurY) {
          if (checkedY === maxY) {
            newOptions = options.filter(
              (option) => Number(option) >= curM && Number(option) <= maxM
            )
          } else {
            newOptions = options.filter((option) => Number(option) >= curM)
          }
        } else {
          if (checkedY === maxY) {
            newOptions = options.filter((option) => Number(option) <= maxM)
          }
        }
      }
      if (type === 'day') {
        if (isCurY) {
          if (checkedY === maxY) {
            if (isCurM) {
              if (checkedM === maxM) {
                newOptions = options.filter(
                  (option) => Number(option) >= curD && Number(option) <= maxD
                )
              } else {
                newOptions = options.filter((option) => Number(option) >= curD)
              }
            } else {
              if (checkedM === maxM) {
                newOptions = options.filter((option) => Number(option) <= maxD)
              }
            }
          }
        } else {
          if (checkedY === maxY) {
            if (checkedM === maxM) {
              newOptions = options.filter((option) => Number(option) <= maxD)
            }
          }
        }
      }

      return newOptions
    },
    filterEndDay(type, options) {
      const currentCheckedDate = dayjs(this.startDate)
      const curY = dayjs().year()
      const curM = Number(dayjs().format('MM'))
      const curD = Number(dayjs().format('DD'))

      const singleMaxMakeTime = this.appointmentConfig.appointmentShowDays
        ? this.appointmentConfig.appointmentShowDays
        : 1 // 用于天、自定义时间

      const maxMakeDay = dayjs(this.startDate).add(singleMaxMakeTime - 1, 'day') //最大预约天数

      const maxY = maxMakeDay.year()
      const maxM = Number(maxMakeDay.format('MM'))
      const maxD = Number(maxMakeDay.format('DD'))

      const isCurY =
        dayjs().format('YYYY') === currentCheckedDate.format('YYYY')
      const isCurM =
        dayjs().format('YYYY-MM') === currentCheckedDate.format('YYYY-MM')
      const checkedY = currentCheckedDate.year()
      const checkedM = currentCheckedDate.month() + 1

      if (type === 'year') {
        return options.filter(
          (option) => Number(option) >= curY && Number(option) <= maxY
        )
      }
      if (type === 'month') {
        if (isCurY) {
          if (checkedY === maxY) {
            return options.filter(
              (option) => Number(option) >= curM && Number(option) <= maxM
            )
          } else {
            return options.filter((option) => Number(option) >= curM)
          }
        } else {
          if (checkedY === maxY) {
            return options.filter((option) => Number(option) <= maxM)
          }
        }
      }
      if (type === 'day') {
        if (isCurY) {
          if (checkedY === maxY) {
            if (isCurM) {
              if (checkedM === maxM) {
                return options.filter(
                  (option) => Number(option) >= curD && Number(option) <= maxD
                )
              } else {
                return options.filter((option) => Number(option) >= curD)
              }
            } else {
              if (checkedM === maxM) {
                return options.filter((option) => Number(option) <= maxD)
              }
            }
          }
        } else {
          if (checkedY === maxY) {
            if (checkedM === maxM) {
              return options.filter((option) => Number(option) <= maxD)
            }
          }
        }
      }
      return options
    },
    // 过滤年月日-开始
    filterStartDateDay(type, options) {
      const curOptions = this.filterStartDay(type, options)
      return curOptions
    },
    // 过滤年月日-结束
    filterEndDateDay(type, options) {
      const curOptions = this.filterEndDay(type, options, this.endDate)
      return curOptions
    },
    // 确认开始 天
    handleConfirmStartDay(date) {
      let time1 = dayjs(date).format('YYYY-MM-DD HH:mm:ss').split(' ')[0]
      let time2 = dayjs(this.startDate).format('YYYY-MM-DD HH:mm:ss').split(' ')[1]
      let time3 = dayjs(this.endDate).format('YYYY-MM-DD HH:mm:ss').split(' ')[1]
      let timeS = time1 + ' ' + time2
      let timeE = time1 + ' ' + time3
      date = new Date(fixNewDate(timeS))
      let dateE = new Date(fixNewDate(timeE))
      this.startDate = date

      this.showStartDatePopup = false
      this.endDate = dateE

      const singleMaxMakeTime = this.appointmentConfig.appointmentShowDays
        ? this.appointmentConfig.appointmentShowDays
        : 1 // 用于天、自定义时间
      let maxEndDate = new Date(this.startDate)
      maxEndDate.setDate(
        this.startDate.getDate() + Number(singleMaxMakeTime) - 1
      )
      if (maxEndDate.getTime() > this.maxStartDate.getTime()) {
        this.maxEndDate = this.maxStartDate
      } else {
        this.maxEndDate = maxEndDate
      }

      this.diffNum = dayjs(this.endDate).diff(this.startDate, 'day') + 1

      // const rangeDateForSubmit = excludeTimeRanges(
      //   {
      //     startTime: formatDateYMDHMS(this.startDate),
      //     endTime: `${formatDateYMD(this.endDate)} 23:59:59`,
      //   },
      //   this.bookedDates
      // )
      const rangeDateForSubmit = getRangesByStartEnd(
        moment(this.startDate),
        moment(this.endDate),
        this.appointmentConfig
      )

      this.onChangeDate('start', this.startDate, this.endDate, rangeDateForSubmit)
      // this.onChangeDate('end', this.endDate, rangeDateForSubmit)
    },
    handleConfirmEndDay(date) {
      let time1 = dayjs(date).format('YYYY-MM-DD HH:mm:ss').split(' ')[0]
      let time2 = dayjs(this.endDate).format('YYYY-MM-DD HH:mm:ss').split(' ')[1]
      let time3 = dayjs(this.startDate).format('YYYY-MM-DD HH:mm:ss').split(' ')[1]
      let time = time1 + ' ' + time2
      let timeS = time1 + ' ' + time3
      date = new Date(fixNewDate(time))
      this.endDate = date
      this.showEndDatePopup = false

      if (dayjs(date).isBefore(this.startDate)) {
        this.startDate = new Date(fixNewDate(timeS))
      }

      let diff =
        moment(`${formatDateYMD(this.endDate)} 23:59:59`).diff(
          formatDateYMDHMS(this.startDate),
          'day'
        ) + 1
      // 计算已经预约的天数
      let bookedNum = 0 // 已经预约的天数
      this.bookedDates.forEach((v) => {
        bookedNum += moment(v.endTime).diff(v.startTime, 'day') + 1
      })
      // 控件选择的总天数，减去已经预约的天数
      diff = diff - bookedNum

      const singleMaxMakeTime = this.appointmentConfig.appointmentShowDays
        ? this.appointmentConfig.appointmentShowDays
        : 1 // 用于天、自定义时间
      if (diff > singleMaxMakeTime) {
        Toast(this.$t('超过了单次可预约的最大天数'))
        this.startDate = new Date(fixNewDate(timeS))
        diff = 1
      }
      this.diffNum = diff

      // const rangeDateForSubmit = excludeTimeRanges(
      //   {
      //     startTime: formatDateYMDHMS(this.startDate),
      //     endTime: `${formatDateYMD(date)} 23:59:59`,
      //   },
      //   this.bookedDates
      // )
      const rangeDateForSubmit = getRangesByStartEnd(
        moment(this.startDate),
        moment(this.endDate),
        this.appointmentConfig
      )
      this.onChangeDate('start', this.startDate, date, rangeDateForSubmit)
      // this.onChangeDate('end', date, rangeDateForSubmit)
    },
    handleChangeStartDay(event) {
      const cY = event.getValues()[0]
      const cM = event.getValues()[1]
      const cD = event.getValues()[2]
      this.changeStartValue = `${cY}-${cM}-${cD}`
    },
  },
  mounted() {
    this.initSetDate()
  },
  watch: {
    checkedStationId(newValue, oldValue) {
      newValue && this.initQuery()
    },
  },
  props: ['appointmentConfig', 'onChangeDate', 'checkedStationId', 'dayStartTime', 'dayEndTime'],
}
</script>
<style lang="less" scoped>
.renderDay {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;

  .firstDateFormBlock {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .firstDateForm {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1e2329;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }

  .firstDateText {
    display: flex;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #474D57;
    line-height: 24px;
  }

  .firstDateLine {
    margin-left: 5px;
    margin-right: 5px;
  }

  .arrow_left {
    width: 24px;
    height: 24px;
  }
}

.appointmentTime {
  padding: 10px 0 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b7bdc6;
  border-top: 1px solid rgba(234, 236, 239, 0.5);
}
</style>
